import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from 'src/environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-enterpreneur-resource',
  templateUrl: './enterpreneur-resource.component.html',
  styleUrls: ['./enterpreneur-resource.component.css']
})
export class EnterpreneurResourceComponent implements OnInit {

  skip: number = 0;
  limit: number = 100;
  allResources: [] = [];
  user: any;

  constructor(
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder,
    public router: Router,
    public authenticationService: AuthenticationService,
    private ngxService: NgxUiLoaderService,
  ) { }

  ngOnInit(): void {
    this.user = this.authenticationService.currentUserValue;
    this.getAllResource();
  }

  getAllResource() {
    this.ngxService.start();
    this.authenticationService.getAllResources(this.skip, this.limit)
      .subscribe((res: any) => {
        console.log("res", res)
        this.allResources = res.items;
        console.log(res.items);
        this.ngxService.stop();
      }, error => {
        if (error) {
          Swal.fire(
            "error",
            error.error.message
          );
          this.ngxService.stop();
        }
      });
  }

  goToLink(link: string) {
    const isAbsoluteUrl = link.startsWith('http://') || link.startsWith('https://');
    const absoluteUrl = isAbsoluteUrl ? link : 'http://' + link;
    window.open(absoluteUrl, '_blank');
  }

}
